import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    Renderer2
} from '@angular/core';

@Directive({
    selector: '[uiDragNDrop]'
})
export class DragNDropDirective {

    @Input() private dragOverHtmlClass?: string = 'dragover';
    @Output() onFilesDrop: EventEmitter<FileList> = new EventEmitter<FileList>();

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    @HostListener('dragenter', ['$event'])
    @HostListener('dragover', ['$event'])
    onDragEnter(event: Event): void {
        this.defaultHandleEvent(event, 'addClass');
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(event: Event): void {
        this.defaultHandleEvent(event, 'removeClass');
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent): void {
        this.defaultHandleEvent(event, 'removeClass');

        const files: FileList = event.dataTransfer.files;
        this.onFilesDrop.emit(files);
    }

    private defaultHandleEvent(event: Event,  action: string): void {
        event.preventDefault();
        event.stopPropagation();

        this.renderer[action](this.elementRef.nativeElement, this.dragOverHtmlClass);
    }
}
